export default __webpack_public_path__ + "static/media/svg.dd205679.svg";